import React from 'react'
import { Grid, Typography, Card, CardContent, useTheme } from '@mui/material'
import { Field, useFormikContext } from 'formik'
import { makeStyles } from '@mui/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { TextField } from 'formik-material-ui'
import MuiDatePicker from './inputs/MuiDatePicker'
import ProfileCountrySelector from './inputs/ProfileCountrySelector'
import 'react-toastify/dist/ReactToastify.css'
import DegreeImagesUploader from './DegreeImagesUploader'
import ExpImagesUploader from './ExpImagesUploader'
import VideoUploader from './VideoUploader'
import TeacherAvatarUploader from './TeacherAvatarUploader'
import styled from '@emotion/styled'

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '80%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '60%',
    },
  },
  degreeImageCard: {
    maxWidth: 300,
  },
  degreeImage: {
    width: '100%',
    height: 'auto',
  },
  expImage: {
    width: '100%',
    height: 'auto',
  },
}))

const FormControlWrapper = styled(Grid)({
  marginBottom: '1em',
  minWidth: '100%'
})

const ProfileTeacherPage2 = () => {
  const { values } = useFormikContext()

  const classes = useStyles()

  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <Grid
      item
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      spacing={3}
    >
      <Grid item>
        <Typography
          variant="h5"
          align="center"
          style={{
            textTransform: 'uppercase',
            fontWeight: 600,
          }}
        >
          Edit profile
        </Typography>
      </Grid>

      <Grid item>
        <Typography variant="body2">
          <span style={{ color: 'red' }}>( * ) Required input</span>
        </Typography>
      </Grid>

      <Grid item>
        <TeacherAvatarUploader />
      </Grid>

      <Grid
        item
        style={
          matchesLG
            ? { maxWidth: '60%' }
            : matchesMD
              ? { maxWidth: '80%' }
              : null
        }
      >
        <Card>
          <CardContent>
            <Grid item>
              <Typography variant="h6" style={{ textAlign: 'center' }}>
                Personal information
              </Typography>
            </Grid>

            <Grid container justifyContent="center" alignItems="center">
              <FormControlWrapper item>
                <MuiDatePicker />
              </FormControlWrapper>

              <FormControlWrapper item>
                <div>
                  <label htmlFor={'abc'} style={{ fontWeight: 400 }}>
                    Choose your nationality:{' '}
                    <span style={{ color: 'red' }}>( * )</span>
                  </label>
                  <br />
                  <ProfileCountrySelector />
                </div>
              </FormControlWrapper>

              <FormControlWrapper item>
                <Field
                  name="phoneNumber"
                  type="text"
                  component={TextField}
                  label={
                    <div>
                      Your phone number:{' '}
                      <span style={{ color: 'red' }}>( * )</span>
                    </div>
                  }
                  style={{ minWidth: '100%' }}
                />
              </FormControlWrapper>

              <FormControlWrapper item>
                <Field
                  name="introduction"
                  type="text"
                  component={TextField}
                  label={
                    <div>
                      Let's write a short paragraph for students to know more
                      about you: <span style={{ color: 'red' }}>( * )</span>
                    </div>
                  }
                  multiline
                  rows={5}
                  style={{ minWidth: '100%' }}
                />
              </FormControlWrapper>

              <FormControlWrapper item>
                <Field
                  name="skypeId"
                  type="text"
                  component={TextField}
                  label={
                    <div>
                      Your Skype Id: <span style={{ color: 'red' }}>( * )</span>
                    </div>
                  }
                  style={{ minWidth: '100%' }}
                />
              </FormControlWrapper>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid
        item
        style={
          matchesLG
            ? { maxWidth: '60%' }
            : matchesMD
              ? { maxWidth: '80%' }
              : null
        }
      >
        <Card>
          <CardContent>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <Typography variant="h6">
                  Your card's information:
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  We use this information to send you the money for your finished
                  booked lessons.
                </Typography>
              </Grid>
              <FormControlWrapper item>
                <Field
                  name="cardNumber"
                  type="text"
                  component={TextField}
                  label="Card number"
                  style={{ minWidth: '100%' }}
                />
              </FormControlWrapper>

              <FormControlWrapper item>
                <Field
                  name="nameOnCard"
                  type="text"
                  component={TextField}
                  label="Name on card"
                  style={{ minWidth: '100%' }}
                />
              </FormControlWrapper>

              <FormControlWrapper item>
                <Field
                  name="bankName"
                  type="text"
                  component={TextField}
                  label="Bank's name"
                  style={{ minWidth: '100%' }}
                />
              </FormControlWrapper>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item className={classes.formControl}>
        <VideoUploader />
      </Grid>

      {values && values.typeOfTeacher === 'professional' && (
        <Grid item className={classes.formControl}>
          <DegreeImagesUploader />
        </Grid>
      )}

      {values && values.typeOfTeacher === 'professional' && (
        <Grid item className={classes.formControl}>
          <ExpImagesUploader />
        </Grid>
      )}
    </Grid>
  );
}

export default ProfileTeacherPage2
